'use client';

/** @jsxImportSource @emotion/react */
import { useTranslations } from 'next-intl';
import { SnakeBanner } from '@wci-tech/core-ui';
import { useStyles } from './LandingHeroBanner.styles';
import { useThemeMode } from '@/context';

const HeroBanner = () => {
  const styles = useStyles();
  const t = useTranslations('HeroBanner');
  const { isDark } = useThemeMode();

  const desktopImg = isDark
    ? './images/hero-banner-desktop-dark.png'
    : './images/hero-banner-desktop-light.png';
  const tabletImg = isDark
    ? './images/hero-banner-tablet-dark.png'
    : './images/hero-banner-tablet-light.png';
  const mobileImg = isDark
    ? './images/hero-banner-mobile-dark.png'
    : './images/hero-banner-mobile-light.png';

  const bannerContent = {
    title: t('title'),
    subtitle: t('subtitle'),
    description: t('description'),
  };

  const bannerTargets = {
    1: t('targets.1'),
    2: t('targets.2'),
    3: t('targets.3'),
    4: t('targets.4'),
    5: t('targets.5'),
  };

  return (
    <section id="home">
      <SnakeBanner
        variant={isDark ? 'secondary' : 'primary'}
        speed={0.6}
        content={bannerContent}
        targets={bannerTargets}
        customStyles={{
          imageContainer: styles.imageContainer,
          contentWrapper: styles.contentWrapper,
          titleWrapper: styles.titleWrapper,
          primaryTitle: styles.primaryTitle,
          secondaryTitle: styles.secondaryTitle,
          description: styles.description,
          tokenName: styles.tokenName,
        }}
        responsiveTargets={{
          mobile: [
            { id: 1, x: 75, y: 70.4 },
            { id: 2, x: 75.6, y: 55.5 },
            { id: 3, x: 75.6, y: 40 },
            { id: 4, x: 18, y: 40 },
            { id: 5, x: 18, y: 60 },
            { id: 6, x: 18, y: 75 },
            { id: 7, x: 48, y: 75 },
            { id: 8, x: 48, y: 160 },
          ],
          small_tablet: [
            { id: 1, x: 58.0, y: 74.0 },
            { id: 2, x: 92, y: 47.6 },
            { id: 3, x: 92, y: 17.0 },
            { id: 4, x: 8.0, y: 17.0 },
            { id: 5, x: 8.0, y: 60.0 },
            { id: 6, x: 8.0, y: 75 },
            { id: 7, x: 48, y: 85 },
            { id: 8, x: 48, y: 160 },
          ],
          tablet: [
            { id: 1, x: 58.4, y: 75.8 },
            { id: 2, x: 89.8, y: 55.4 },
            { id: 3, x: 89.8, y: 24 },
            { id: 4, x: 8.3, y: 24 },
            { id: 5, x: 8.3, y: 24 },
            { id: 6, x: 14.3, y: 82 },
            { id: 7, x: 50, y: 82 },
            { id: 8, x: 50, y: 160 },
          ],
          laptop: [
            { id: 1, x: 58.0, y: 70.0 },
            { id: 2, x: 90.0, y: 50.0 },
            { id: 3, x: 90.0, y: 15.6 },
            { id: 4, x: 10.5, y: 16.0 },
            { id: 5, x: 10.5, y: 65.0 },
            { id: 6, x: 8.5, y: 70 },
            { id: 7, x: 48, y: 90 },
            { id: 8, x: 48, y: 160 },
          ],
          desktop: [
            { id: 1, x: 58.3, y: 73.3 },
            { id: 2, x: 82, y: 56.3 },
            { id: 3, x: 82, y: 14.7 },
            { id: 4, x: 18, y: 14.7 },
            { id: 5, x: 18, y: 60.5 },
            { id: 6, x: 18, y: 80 },
            { id: 7, x: 48, y: 80 },
            { id: 8, x: 48, y: 160 },
          ],
        }}
        desktopImgSrc={desktopImg}
        tabletImgSrc={tabletImg}
        mobileImgSrc={mobileImg}
      />
    </section>
  );
};

export default HeroBanner;
